import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the PaginasProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PaginasProvider {

  constructor(public http: HttpClient) {
    console.log('Hello PaginasProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/paginas/paginas.ts